import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import Modals from "../../../components/modal";
import { useExport } from "./hooks";
import ExportForm from "./form/export-form";
import { useUser } from "./../../../common-hooks/user";

const ExportComponent = (props) => {
  const {
    toggleModal,
    isOpenModal,
    isLoading,
    downloadScheduleEventsReport,
    dateError,
    setDateError,
  } = useExport(props);

  const { isCoordinator } = useUser();

  if (isCoordinator) {
    return null;
  }

  return (
    <div>
      <Tooltip
        title="Download Schedule Events"
        placement="bottom"
        className="download__schedule_event_report"
      >
        <i
          className="fa fa-file-excel-o fa-2x icon-btn-action"
          onClick={toggleModal}
        ></i>
      </Tooltip>
      {isOpenModal ? (
        <Modals
          isOpenModal
          setIsOpenModal={toggleModal}
          message={
            <ExportForm
              isLoading={isLoading}
              downloadScheduleEventsReport={downloadScheduleEventsReport}
              dateError={dateError}
              setDateError={setDateError}
            />
          }
          title="Export Schedule Events"
        />
      ) : null}
    </div>
  );
};

export default ExportComponent;
